import { useSearchParams } from 'react-router-dom';
import { PageContent } from '@/components';
import { ContentSwitcherTabPanel } from '@/design-system';
import { JarFlyerboardList } from './JarFlyerboardList';
import { JarFollowingOrgsList } from './JarFollowingOrgsList';
import { JarHeader } from './JarHeader';

export const JAR_TABS = {
  ALL: 'all',
  FOLLOWING_ORGS: 'following-orgs',
} as const;

export type JarTab = typeof JAR_TABS[keyof typeof JAR_TABS];

const JAR_TAB_GROUP_ID = 'jar-tab-group';

const JAR_TAB_PARAM = 'tab';

const isJarTab = (value: string | null): value is JarTab =>
  value === JAR_TABS.ALL || value === JAR_TABS.FOLLOWING_ORGS;

export const Jar: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab: JarTab = isJarTab(searchParams.get(JAR_TAB_PARAM))
    ? (searchParams.get(JAR_TAB_PARAM) as JarTab)
    : JAR_TABS.ALL;

  const onTabChange = (tab: string): void => {
    const newSearchParams = new URLSearchParams(searchParams);
    newSearchParams.set(JAR_TAB_PARAM, tab);
    setSearchParams(newSearchParams, { replace: true });
  };

  return (
    <>
      <JarHeader activeTab={activeTab} onTabChange={onTabChange} tabGroupId={JAR_TAB_GROUP_ID} />
      <ContentSwitcherTabPanel
        tabGroupId={JAR_TAB_GROUP_ID}
        activeTab={activeTab}
        data-testid="jarContent"
      >
        <PageContent>
          {activeTab === JAR_TABS.ALL ? (
            <JarFlyerboardList />
          ) : (
            <JarFollowingOrgsList onBrowseAll={() => onTabChange(JAR_TABS.ALL)} />
          )}
        </PageContent>
      </ContentSwitcherTabPanel>
    </>
  );
};
